import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithLicenseProductPackages = { licenseProductPackages: FilterState };

const licenseProductPackages = createSlice({
    name: 'licenseProductPackages',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default licenseProductPackages.reducer;
export const { addNewFilter, removeFilter, clearFilters } = licenseProductPackages.actions;
export const selectFilters = (state: StateWithLicenseProductPackages) => state.licenseProductPackages.filters;
